import { defineComponent as _defineComponent } from 'vue';
import {} from "@/api";
import DatasetSource from "@/components/DatasetInformation/DatasetSource.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetSources',
    props: {
        sources: null
    },
    setup(__props) {
        return { __sfc: true, DatasetSource };
    }
});
